export default __webpack_public_path__ + "static/media/avatar8.8dac81eb.png";